import ReactDOM from "react-dom";
import Icon from "../../core/icon/Icon";

const SimpleLoader = () => {
  return ReactDOM.createPortal(
    <div className="text-text-default fixed inset-0 z-[99] flex items-center justify-center bg-white">
      <Icon
        name="loading"
        className="h-10 w-10"
      />
    </div>,
    document.body
  );
};

export default SimpleLoader;
